import React from 'react'
import { images, files } from '../../constants'
import { motion } from 'framer-motion'
import './Menu.css'

const Menu = () => {
  const imageAnimate = {
    offscreen: { x: 100, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }
  return (
    <motion.div
      className="container-xxl mt-5 mb-5"
      id="menu"
      initial={'offscreen'}
      whileInView={'onscreen'}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ staggerChildren: 0.5 }}
    >
      <div className="row">
        <div className="col-sm-8 mt-5 order-sm-2">
          <motion.img
            src={images.menu}
            alt="menu"
            class="img-fluid"
            variants={imageAnimate}
          />
        </div>
        <div className="col-sm-4 d-flex align-items-end order-sm-1 p-4">
          <div className="menu">
            <motion.h1 variants={textAnimate}>Menu</motion.h1>
            <motion.a
              href="/menu"
              variants={textAnimate}
            >
              View our menu →
            </motion.a>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Menu
